import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [];

  share(event) {
    event.preventDefault();

    const site = event.target.dataset.site;
    const openAs = event.target.dataset.openAs;
    const url = this.getUrl();
    const title = this.getTitle();
    const img = this.getImage();

    switch (site) {
      case "email":
        this.shareViaEmail(title, url);
        break;
      case "facebook":
        this.shareViaFacebook(url, openAs);
        break;
      case "linkedin":
        this.shareViaLinkedin(url, title, openAs);
        break;
      case "whatsapp":
        this.shareViaWhatsapp(url, openAs);
        break;
      case "link":
        this.copyToClipboard(url);
        break;
    }
  }

  getTitle() {
    return encodeURIComponent(this.element.getAttribute("data-title") || '');
  }

  getImage() {
    return encodeURIComponent(this.element.getAttribute("data-img") || '');
  }

  getUrl() {
    let url = encodeURIComponent(this.element.getAttribute("data-url") || '');
    if (url.length === 0) {
      url = encodeURIComponent(window.location.href);
    }
    return url;
  }

  shareViaEmail(title, url) {
    const mailtoLink = `mailto:?subject=${title}&body=${url}`;
    window.location.href = mailtoLink;
  }

  shareViaFacebook(url, openAs) {
    const facebookUrl = `http://www.facebook.com/sharer/sharer.php?u=${url}`;
    this.openUrl(facebookUrl, 555, 400, openAs);
  }

  shareViaLinkedin(url, title, openAs) {
    const linkedinUrl = `https://www.linkedin.com/shareArticle?mini=true&url=${url}&title=${title}`;
    this.openUrl(linkedinUrl, 555, 400, openAs);
  }

  shareViaWhatsapp(url, openAs) {
    const whatsappUrl = `https://api.whatsapp.com/send?text=${url}`;
    this.openUrl(whatsappUrl, 555, 400, openAs);
  }

  copyToClipboard(url) {
    const copyText = document.createElement("textarea");
    copyText.value = decodeURIComponent(url);
    document.body.appendChild(copyText);
    copyText.select();
    document.execCommand("copy");
    document.body.removeChild(copyText);
    this.showCopiedMessage();
  }

  openUrl(url, width, height, openAs) {
    if (openAs === 'popup') {
      const left = (window.screen.width / 2) - (width / 2);
      const top = (window.screen.height * 0.3) - (height / 2);
      const options = `width=${width},height=${height},left=${left},top=${top},menubar=no,status=no,location=no`;
      window.open(url, 'popup', options);
    } else if (openAs === 'new_tab') {
      window.open(url, '_blank');
    }
  }

  showCopiedMessage() {
    const copiedMessage = document.querySelector('.copied-message');
    copiedMessage.style.display = 'block';

    copiedMessage.classList.remove('translate-y-full');
    copiedMessage.classList.add('translate-y-0');

      setTimeout(() => {
        copiedMessage.style.display = 'none';
    }, 3000);
  }
}
